import { httpGet, httpPost } from "@/request/http";

let path = "/directoryFoods";

export default {
  getPages(dTO) {
    return httpGet(`${path}/pages`, dTO);
  },
  getFoodsByFoodKind(id, foodKindId) {
    return httpGet(`${path}/directorys/${id}/foodKinds/${foodKindId}/foods`);
  },
  getFoods(id) {
    return httpGet(`${path}/directorys/${id}/foods`);
  },
  add(items) {
    return httpPost(`${path}/addbatch`, items);
  },
  remove(items) {
    return httpPost(`${path}/deletebatch`, items);
  },
};
